import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastr: ToastrService,
    private router: Router,) { }

  showSuccess(message: string | undefined, title: string | undefined) {
    this.toastr.success(message, title)
  }

  showCustom(message: string | undefined, title: string | undefined, config: any) {
    this.toastr.success(message, title, config);
  }

  showError(message: string | undefined, title: string | undefined) {
    this.toastr.error(message, title)
  }

  showInfo(message: string | undefined, title: string | undefined) {
    this.toastr.info(message, title)
  }

  showWarning(message: string | undefined, title: string | undefined) {
    this.toastr.warning(message, title)
  }

  showSuccessEvent(message: string | undefined, title: string | undefined, url: string | undefined) {
    this.toastr.success(message, message)
      .onTap
      .pipe()
      .subscribe(() => this.toasterClickedHandler(url));
  }

  toasterClickedHandler(url: string | undefined) {
    this.router.navigate([url]);
  }

  hideMessage() {
    this.toastr.clear();
  }

}
